skrilla.controller('queryUserIdModalCtrl', function ($scope, cacheService, modalService) {
    $scope.pageKey = "users";
    $scope.users = cacheService.getObjectOrElse("usersTable", []);

    $scope.clicked = function(id){
        cacheService.registerObject("queryUserId", id);
        modalService.dismissAll();
    }

});